<template>
  <v-flex xs12 class="relative-position">
    <div class="title my-3 ml-3">
      Partes
    </div>
    <v-data-table v-model="selected" :headers="columns" :items="partes"
                  :pagination.sync="serverPagination" :total-items="serverPagination.rowsNumber"
                  :loading="loading" hide-actions select-all
                  item-key="NumeroOrden" class="elevation-3 tabla-incidencia" style="margin: 0px auto;"
    >
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox :input-value="!!selected.length" :indeterminate="props.indeterminate" primary hide-details
                        on-icon="mdi-minus" off-icon="mdi-plus" indeterminate-value="mdi-minus-box" style="width: 20px;" @click.native="toggleAll"
            />
          </th>
          <th v-for="header in props.headers" :key="header.text" class=" text-center">
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :class="tableEvenOdd(props.index)" @dblclick.native="props.selected = !props.selected">
          <td align="center" class="" style="width: 10px">
            <v-checkbox v-model="props.selected" color="primary" on-icon="mdi-minus" off-icon="mdi-plus" hide-details />
          </td>
          <td key="Tecnico" aling="center" class="pa-1">
            <v-autocomplete v-model="props.item.Tecnico" :readonly="isDisabled" :items="Tecnicos" :filter="selectFilterIncludes"
                            item-text="label" item-value="value"
                            class="pt-0 mt-0 mb-0 select-inline horizontal-center" style="max-width: 200px; width: 100%; min-width: 150px;" hide-details
            />
          </td>
          <td key="Fecha" align="center" class="pa-1">
            <v-date v-model="props.item.Fecha" :disabled="isDisabled" hide-details class="pt-0 mt-0 mb-0" style="width: 130px" />
          </td>
          <td key="Guardia" align="center" class="pa-1">
            <v-checkbox v-model="props.item.Guardia" :disabled="isDisabled" class=" mt-0 mb-0" style="width: 25px;" hide-details />
          </td>
          <td key="HoraInicio" v-if-tecnico align="center" class="pa-1">
            <v-text-field v-model="props.item.HoraInicio" :readonly="isDisabled" :maxlength="5" class="pt-0 mt-0 mb-0 input-center" style="width: 50px"
                          hide-details
                          @dblclick.native.stop="(event) => event.target.select()"
                          @blur="() => { props.item.HoraInicio = formatHour(props.item.HoraInicio) }"
            />
          </td>
          <td key="HoraFin" v-if-tecnico align="center" class="pa-1">
            <v-text-field v-model="props.item.HoraFin" :readonly="isDisabled" :maxlength="5" class="pt-0 mt-0 mb-0 input-center" style="width: 50px"
                          hide-details
                          @dblclick.native.stop="(event) => event.target.select()"
                          @blur="() => { props.item.HoraFin = formatHour(props.item.HoraFin, props.item.HoraInicio) }"
            />
          </td>
          <td key="Notificable" v-if-tecnico align="center" class="pa-1">
            <v-checkbox v-model="props.item.Notificable" :disabled="isDisabled" class="" style="width: 25px;" hide-details />
          </td>
          <td align="center" class="pa-1">
            <v-btn v-if="estado !== 'A' && estado !== 'C'" v-if-tecnico style="min-width: 48px;" color="error"
                   small @click="confirmDelete(props.item)"
            >
              <v-icon>mdi-delete-forever</v-icon>
            </v-btn>
          </td>
        </tr>
        <tr v-show="props.selected" :class="tableEvenOdd(props.index)">
          <td colspan="100%">
            <div class="description mt-sm ml-2">
              <v-textarea v-model="props.item.Descripcion" :readonly="isDisabled" :rows="props.item.Descripcion.split(/\r\n|\r|\n/).length"
                          label="Descripción" class="mb-2" hide-details
              />
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <div v-if="estado !== 'A' && estado !== 'C'" id="actionsIncidencia" v-if-tecnico class="layout row justify-center mt-3">
      <v-btn v-scroll-to="{ el: '#actionsIncidencia', duration: 700 }" outline fab color="primary" @click="addRow">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <inner-loading :visible="loading" style="background-color:white;" />
  </v-flex>
</template>

<script>
import { Entities, Forms } from '@/mixins/index.js'
import InnerLoading from '@/components/InnerLoading'
import VDate from '@/components/VDate'
import moment from 'moment'
import store from '@/store/index.js'

export default {
  name: 'PageIndex',
  components: { InnerLoading, VDate },
  mixins: [Entities, Forms],
  props: {
    cliente: { type: Number, default: 0 },
    instalacion: { type: Number, default: 0 },
    incidencia: { type: Number, default: 0 },
    estado: { type: String, default: '' }
  },
  data () {
    return {
      profile: store.getters['getProfile'],
      isTecnico: false,
      serverPagination: {
        page: 1,
        rowsPerPage: 100,
        rowsNumber: 1
      },
      columns: [
        { text: 'Técnico', value: 'Tecnico', align: 'center', sortable: false, visible: true },
        { text: 'Fecha', value: 'Fecha', align: 'center', sortable: false, visible: true },
        { text: '¿Guardia?', value: 'Guardia', align: 'center', sortable: false, visible: true },
        { text: 'Hora Inicio', value: 'HoraInicio', align: 'center', sortable: false, visible: this.$store.getters.Tecnico },
        { text: 'Hora Fin', value: 'HoraFin', align: 'center', sortable: false, visible: this.$store.getters.Tecnico },
        { text: '¿Notificar?', value: 'Notificable', align: 'center', sortable: false, visible: this.$store.getters.Tecnico }
      ],
      loading: false,
      selected: [],
      select: null,
      partes: [],
      menuFecha: false
    }
  },
  computed: {
    isDisabled () {
      return this.estado === 'C' || this.estado === 'A' || !this.$store.getters.Tecnico
    }
  },
  watch: {
    partes () {
      if (this.partes.length === 0) this.selected = []
      else if (this.partes.length) { this.selected = this.selected.concat(this.partes[this.partes.length - 1]) }
    }
  },
  created () {
    setTimeout(() => {
      this.asyncTecnicos()
    }, 5)
    this.selected = []
    this.partes = []
  },
  methods: {
    getRol: function () {
      if (this.profile.Role === 'Tecnico') {
        this.isTecnico = true
      }
    },
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.partes.slice()
      this.selected.splice()
    },
    request () {
      var filas = 100
      if (this.incidencia) {
        this.loading = true
        this.axios
          .get(this.$apiUrl('trabajosRealizados') + `?rows=${filas}&page=${0}&Cliente=${this.cliente}&Instalacion=${this.instalacion}&Incidencia=${this.incidencia}`,
            { headers: { 'Content-Type': 'application/json' } })
          .then(async ({ data }) => {
            if (data) {
              this.serverPagination.rowsNumber = data.recordsFiltered
              // var startTime, endTime
              // startTime = new Date()
              this.partes = data.datas ? data.data : []
              this.selected = []
              if (data.data) {
                // for (var val of data.data) {
                let i = 0, step = 5
                while (this.partes.length < data.data.length) {
                  this.partes.push(...data.data.slice(i, i + step))
                  this.selected = []
                  i += step
                  await new Promise(resolve => setTimeout(resolve, 650))
                }
              }
              // endTime = new Date()
              // var timeDiff = endTime - startTime // in ms
              // console.log(timeDiff + ' ms')
              if (this.$store.getters['getProfile'].Role === 'Cliente') {
                var partesaux = []
                for (var z = 0; z < this.partes.length; z++) {
                  if (this.partes[z].Notificable) {
                    partesaux.push(this.partes[z])
                  }
                }
                this.partes = partesaux
              }
              if (this.partes.length < 7) this.selected = this.partes
            }
          })
          .catch(() => { })
          .then(() => { this.loading = false })
      }
    },
    addRow () {
      this.partes.push({
        Cliente: this.cliente,
        Instalacion: this.instalacion,
        Incidencia: this.incidencia,
        NumeroOrden: this.partes.length + 1,
        Tecnico: this.$store.getters['getTecnico'],
        Fecha: new Date(),
        Descripcion: '',
        HoraInicio: this.formatHour(Date.now()),
        HoraFin: '',
        ClaveIncidencia: 5,
        ClaveFacturacion: 0,
        Guardia: false,
        Notificable: false,
        isNew: true
      })
      // this.$scrollTo('#actionsIncidencia', 100, {easing: 'linear'})
      // this.selected.push(this.partes[this.partes.length - 1])
    },
    confirmDelete (parte) {
      let index = this.partes.indexOf(parte)
      if (index <= -1) {
        this.$notify({ message: 'Parte no encontrado', type: 'error' })
      } else {
        this.$root.$confirm.open('Va a eliminar el parte',
          '¿Está seguro de querer eliminar este parte? Esta acción no se podrá revertir.',
          { ok: { color: 'error' }, cancel: { autofocus: true } })
          .then(() => { this.deleteRow(parte, index) })
      }
    },
    deleteRow (parte, index) {
      if (parte.Incidencia && !parte.isNew) {
        this.axios({ method: 'delete',
          url: this.$apiUrl('trabajosRealizados') + `?cliente=${parte.Cliente}&instalacion=${this.instalacion}&incidencia=${parte.Incidencia}&numeroOrden=${parte.NumeroOrden}`
        }).then(response => {
          this.partes.splice(index, 1)
          this.$notify({ message: 'Parte eliminado correctamente' })
        })
      } else {
        this.partes.splice(index, 1)
        this.$notify({ message: 'Parte eliminado correctamente' })
      }
    },
    formatHour (hour, startOf) {
      let isHour = true
      if (hour && hour.length >= 1) {
        if (hour.length >= 4) {
          hour = hour.replace(':', '')
          hour = moment().hour(hour.substring(0, 2)).minutes(hour.substring(2, 4))
          // startOf = null
        } else if (!startOf) {
          hour = moment().minutes(Math.abs(hour.substring(2, 4)))
        } else { isHour = false }

        if (startOf && startOf.split(':').length === 2) {
          startOf = moment().hour(startOf.split(':')[0]).minutes(startOf.split(':')[1])
          // (hour.length = undefined) => Si es fecha
          // date.isValid(5) => true en Chrome || false en Firefox
          if (isHour) {
            let diff = hour.diff(startOf, 'minutes')
            if (diff >= 0) {
              hour = moment(hour).format('HH:mm')
              return hour
            }
            if (diff < 0) {
              this.$root.$confirm.open('Error',
                'La hora de fin no puede ser menor a la hora de incio.',
                { ok: { color: 'error' }, cancel: { autofocus: true } })
              hour = Date.now()
              hour = moment(hour).format('HH:mm')
              return hour
            }
            hour = 0
          }
          hour = startOf.add(Math.abs(hour) || 0, 'minutes')
        }
      } else { hour = Date.now() }
      hour = moment(hour).format('HH:mm')
      return hour
    }
  }
}
</script>

<style>
.q-table tbody td {
  padding-top: 4px;
  padding-bottom: 4px;
}
</style>
